const IN_APP_BROWSER_UA =
  /Instagram|FBAN|FBAV|FB_IAB|FB4A|FBIOS|Line\/|Twitter|Snapchat|TikTok|musical_ly|BytedanceWebview|WhatsApp|MicroMessenger|Pinterest|LinkedInApp|; wv\)/i;

export const isInAppBrowser = (userAgent = typeof navigator === 'undefined' ? '' : navigator.userAgent): boolean => {
  return IN_APP_BROWSER_UA.test(userAgent);
};
